const BRAZIL_COUNTRY_CODE = '55';
const BRAZIL_LOCAL_PHONE_LENGTHS = [10, 11];

/**
 * Celular no formato que o bot da Callbell usa no WhatsApp: só dígitos, com o
 * DDI na frente (ex.: 5548999998888). É o que vai no campo personalizado
 * `telefone`, para o mesmo fluxo do bot servir ao Webchat. Número do Brasil
 * sem DDI (DDD + número) ganha o 55; os demais só perdem a máscara.
 */
export default function formatWebchatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '');

  return BRAZIL_LOCAL_PHONE_LENGTHS.includes(digits.length)
    ? `${BRAZIL_COUNTRY_CODE}${digits}`
    : digits;
}
